import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import { func, object, bool } from "prop-types";
import TestSummarySection from "./TestSummarySection";
import { renderDownloadButton } from "../renderHelpers";

const ScoreReportsSection = ({
  handleDownloadPdf,
  handleViewDetailsButton,
  tests,
  hideBaseline,
}) => {
  const TestSummarySections = [];

  if (tests && tests.size > 0) {
    tests.forEach((test, testId) => {
      if (!test) {
        return false;
      }

      TestSummarySections.push(
        <TestSummarySection
          handleDownloadPdf={handleDownloadPdf}
          handleViewDetailsButton={handleViewDetailsButton}
          key={testId} // eslint-disable-line react/no-array-index-key
          test={test}
          testId={testId}
          hideBaseline={hideBaseline}
        />
      );
    });
  }

  const DownloadButton = renderDownloadButton(
    handleDownloadPdf,
    null,
    "Candidate Summary"
  );

  return (
    <Card className="px-3 pt-4">
      <Col>
        <Row className="d-flex justify-content-between mx-1">
          <h2 className="font-weight-bold" style={{ fontSize: "20px" }}>
            Score Reports
          </h2>
          <span
            style={{
              width: "165px",
              marginRight: "-23px",
            }}
          >
            {DownloadButton}
          </span>
        </Row>
        {TestSummarySections.length > 0 ? (
          TestSummarySections
        ) : (
          <div>There is no assessment data for this candidate.</div>
        )}
      </Col>
    </Card>
  );
};

ScoreReportsSection.propTypes = {
  handleDownloadPdf: func.isRequired,
  handleViewDetailsButton: func.isRequired,
  tests: object,
  hideBaseline: bool,
};

export default ScoreReportsSection;
